import { Link, matchPath } from "react-router";
import { getSvg } from "../utils/getSvg";
import Skeleton from "react-loading-skeleton";
import { useAppDispatch, useAppLocation } from "../../app/hooks";
import { JSX } from "react";
import { setIsMenuOpen } from "../../app/rootReducer";

interface Props {
    label: string;
    menuItems: Array<{ label: string; icon: string; link: string }>;
    location: string;
    setLocation: (location: string) => void;
    isLoading?: boolean;
    skeletonCount?: number;
}

export const MenuGroup = (props: Props): JSX.Element => {
    const { pathname } = useAppLocation();
    const dispatch = useAppDispatch();

    if (props.isLoading) {
        return (
            <Skeleton
                count={
                    props.skeletonCount
                        ? props.skeletonCount
                        : props.menuItems.length
                }
                height={"3.4rem"}
                borderRadius={"0.8rem"}
                containerClassName={"c-menu-group"}
            />
        );
    }

    return (
        <div className="c-menu-group">
            <div className="c-menu-group__title">
                <span>{props.label}</span>
            </div>

            <ul className="c-menu-group__list">
                {props.menuItems.map((item, index) => {
                    const isActive =
                        matchPath({ path: item.link, end: false }, pathname) !==
                        null;

                    const className = `c-menu-group__list__item${isActive ? " is-active" : ""}`;

                    return (
                        <li className={className} key={index}>
                            <Link
                                to={item.link}
                                className="c-menu-group__list__item__link"
                                onClick={() => dispatch(setIsMenuOpen(false))}
                            >
                                {getSvg(item.icon)}
                                <span>{item.label}</span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
